import TransactionNewForm from "../Components/TransactionNewForm";

export default function New() {
  return (
    <div>
      <TransactionNewForm />
    </div>
  );
}
